import React from 'react'

import { TabsProps } from 'types/types'

const Tabs: React.FC<TabsProps> = ({ tabs, value, onChange, className = '' }) => {
  const activeTab = tabs.find(tab => tab.value === value)
  return (
    <div className={className}>
      <div className="flex flex-end font-semibold gap-6">
        {tabs.map(tab => {
          const isActive = tab.value === value
          return (
            <div
              key={tab.value}
              className={`${isActive ? 'text-black' : 'text-grey-icon'} ${
                tab.isDisabled ? 'cursor-not-allowed !text-disabled-text' : 'cursor-pointer'
              }`}
              onClick={() => !tab.isDisabled && onChange(tab.value)}
            >
              {tab.label}
              {isActive && (
                <div
                  className="bg-primary rounded-sm mt-1"
                  style={{
                    height: '2px'
                  }}
                />
              )}
            </div>
          )
        })}
      </div>
      {activeTab && <div>{activeTab.content}</div>}
    </div>
  )
}

export default Tabs
